/**
 * Module dependencies.
 */

import { useEffect, useState } from 'react';

/**
 * Export `useViewport` hook.
 */

export function useViewport() {
  const [viewport, setViewport] = useState({
    height: 0,
    width: 0,
  });

  useEffect(() => {
    function updateSize() {
      setViewport({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    // Só executa no cliente
    updateSize();
    window.addEventListener('resize', updateSize);

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return viewport;
}

/**
 * Sizes.
 */

const sizes = [
  16, 32, 64, 128, 192, 256, 320, 384, 448, 512, 576, 640, 704, 768, 832, 896,
  960, 1024, 2048,
];

/**
 * Export `resolveImageWidth` function.
 */

export function resolveImageWidth(width) {
  if (!width) {
    return 1024;
  }

  for (const size of sizes) {
    if (width <= size) {
      return size;
    }
  }

  // Se width for maior que todos os tamanhos, retorna o maior
  return sizes[sizes.length - 1];
}
